export default {
  changeLocaleTitle: "LanguageSwitch {type}"
};
